module.exports = __webpack_public_path__ + "static/media/dz.9740dff8.svg";